import axios from "axios";

export const addToFiles = async (id, fileData) => {
  return await Promise.all(
    fileData.filesUploaded.map((file) => {
      return axios.post(
        `${process.env.REACT_APP_FILES_API}/jagapro-document/add-jagapro-document`,
        {
          jagapro_id: id,
          file_path: file.key,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
    })
  );
};
